import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 2AA1C93A-17BE-4BB6-A85C-C477A4FF1069
 * name road
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/road.svg
 * tags
 * - Transportation + Road 
 */
export const RoadIcon = createSvgIcon(<><path d="M11,16H13V20H11M11,10H13V14H11M11,4H13V8H11M4,22H20V2H4V22Z" /></>, 'RoadIcon');
export default RoadIcon